import { useState, useEffect } from "react";
import axios from "axios";
import { ActivityHistory } from "@/components/DayPlanner";

export default function ActivityHistoryTab({ api }) {
  const [titles, setTitles] = useState(null);
  const [selected, setSelected] = useState("");
  useEffect(() => {
    axios.get(`${api}/activity-titles`).then((r) => {
      setTitles(r.data);
      setSelected((s) => s || r.data[0] || "");
    }).catch(() => setTitles([]));
  }, [api]);
  if (titles === null) return null;
  return (
    <div className="space-y-4" data-testid="activity-history-tab">
      <div>
        <h2 className="font-head text-2xl font-bold text-[var(--hp-heading)]">Activity performance</h2>
        <p className="text-sm text-[var(--hp-muted)] mt-1">How a repeated day activity — a trip to the zoo, a food day — has done year over year: attendance and income, without opening a specific programme's day planner.</p>
      </div>
      {titles.length === 0 ? (
        <p className="text-sm text-[var(--hp-muted)]" data-testid="activity-history-empty">No day activities recorded yet — give one a title in a programme's Day planner and it'll show up here.</p>
      ) : (
        <>
          <div className="flex flex-wrap gap-1.5" data-testid="activity-history-titles">
            {titles.map((t) => (
              <button key={t} data-testid={`activity-history-title-${t}`} onClick={() => setSelected(t)}
                className={`max-w-full rounded-2xl border px-3 py-1.5 text-left text-xs font-semibold [overflow-wrap:anywhere] transition-colors ${selected === t ? "border-[var(--hp-primary)] bg-[var(--hp-primary)]/15 text-[var(--hp-profit)]" : "border-[var(--hp-border-hi)] text-[var(--hp-heading)] hover:bg-[var(--hp-tint-5)]"}`}>{t}</button>
            ))}
          </div>
          {selected && <ActivityHistory api={api} title={selected} />}
        </>
      )}
    </div>
  );
}
